import { render, staticRenderFns } from "./PrefixForm.vue?vue&type=template&id=f17e4a4a"
import script from "./PrefixForm.vue?vue&type=script&lang=js"
export * from "./PrefixForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports